import { DefaultSeo as NextDefaultSeo, DefaultSeoProps } from 'next-seo';
import { getContainer } from '@framework/di/getContainer';
import searchEngineConfig from '@framework/config/searchEngine';
import { TYPES } from './types';
import { ISeoService } from './ISeoService';

const DefaultSeo = (props: Partial<DefaultSeoProps>) => {
  const container = getContainer();
  const seoService = container.get<ISeoService>(TYPES.SeoService);
  const defaultConfig = seoService.getDefaultSeoConfig();

  return (
    <NextDefaultSeo
      dangerouslySetAllPagesToNoIndex={ !searchEngineConfig.allowIndexing }
      dangerouslySetAllPagesToNoFollow={ !searchEngineConfig.allowIndexing }
      { ...defaultConfig }
      { ...props }
    />
);
};

export default DefaultSeo;
